import { Link } from "react-router-dom";
import {
  T, FONT_DISPLAY, FONT_MONO, PageShell, TopNav, Footer,
  container, eyebrow, italicAccent,
} from "@/lib/hybridTheme";

const EFFECTIVE_DATE = "November 15, 2025";

const SECTIONS = [
  { n: "I.", h: "Introduction", body: (
    <p>Clients OnRamp (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) provides a consulting platform that helps small local businesses generate leads. This Privacy Policy describes how we collect, use, share, and protect personal information when you visit our website, use our chat/booking widget, or receive communications from us.</p>
  )},
  { n: "II.", h: "Information we collect", body: (
    <ul style={{ paddingLeft: 22, margin: 0 }}>
      <li><strong>Contact information</strong> — name, phone number, email address, business name — that you provide when you message a Clients OnRamp chat widget, request a callback, or book an appointment.</li>
      <li><strong>Business information</strong> — the business name, address, industry, and public listing data that we source from Google Places to build a free preview website.</li>
      <li><strong>Communication content</strong> — messages you send through our chat widget and any SMS/email replies you send us.</li>
      <li><strong>Technical information</strong> — IP address, browser, device type, and interaction data collected via standard logging.</li>
    </ul>
  )},
  { n: "III.", h: "How we use information", body: (
    <ul style={{ paddingLeft: 22, margin: 0 }}>
      <li>To respond to inquiries, schedule appointments, and provide requested services.</li>
      <li>To send transactional and marketing emails via Resend, and SMS messages via Twilio, ONLY to recipients who have opted in or have an existing business relationship with us.</li>
      <li>To improve our services, agents, and product offerings.</li>
      <li>To comply with legal obligations.</li>
    </ul>
  )},
  { n: "IV.", h: "SMS/messaging consent (A2P 10DLC)", body: (
    <p>By providing your mobile number and opting in, you consent to receive SMS messages from Clients OnRamp regarding your inquiry, appointment, or account. Message frequency varies. Message and data rates may apply. Reply <strong>STOP</strong> to unsubscribe at any time; reply <strong>HELP</strong> for assistance. Mobile opt-in data and consent are not shared with third parties for marketing purposes.</p>
  )},
  { n: "V.", h: "How we share information", body: (
    <p>We do not sell your personal information. We share information only with service providers that help us operate the platform — including Resend (email), Twilio (SMS/voice), Stripe (billing), Google (public business data), and Anthropic (AI processing) — each of which is bound by their own privacy commitments.</p>
  )},
  { n: "VI.", h: "Your rights", body: (
    <p>You may request access to, correction of, or deletion of your personal information by emailing us at the contact address below. You may opt out of marketing at any time.</p>
  )},
  { n: "VII.", h: "Contact", body: (
    <p>Questions about this Privacy Policy or your data can be sent to <span style={{ fontFamily: FONT_MONO, color: T.coral }}>privacy@clientsonramp.local</span> (replace with your business email once verified).</p>
  )},
];

export default function PrivacyPolicy() {
  return (
    <PageShell testId="privacy-policy-page">
      <TopNav />

      <section style={{ padding: "96px 0 40px" }}>
        <div style={container()}>
          <div style={{ maxWidth: 780 }}>
            <div style={eyebrow()}>Legal</div>
            <h1 style={{ fontFamily: FONT_DISPLAY, fontSize: "clamp(48px, 6vw, 80px)", lineHeight: 1.02, letterSpacing: "-0.03em", fontWeight: 400, margin: "16px 0 12px", color: T.ink }}>
              <em style={italicAccent(T.coral)}>Privacy</em> policy
            </h1>
            <div style={{ fontFamily: FONT_MONO, fontSize: 12, color: T.inkMuted, letterSpacing: "0.08em", textTransform: "uppercase" }}>
              Effective {EFFECTIVE_DATE}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "40px 0 96px" }}>
        <div style={container()}>
          <div style={{ maxWidth: 780, background: T.panel, border: `1px solid ${T.line}`, padding: "48px 56px" }}>
            {SECTIONS.map((s) => (
              <section key={s.n} style={{ marginBottom: 40 }}>
                <div style={{ display: "flex", alignItems: "baseline", gap: 16, marginBottom: 14 }}>
                  <span style={{ fontFamily: FONT_DISPLAY, fontSize: 36, fontStyle: "italic", color: T.coral, fontWeight: 400, lineHeight: 1 }}>{s.n}</span>
                  <h2 style={{ fontFamily: FONT_DISPLAY, fontSize: 26, fontWeight: 500, letterSpacing: "-0.01em", margin: 0, color: T.ink }}>{s.h}</h2>
                </div>
                <div style={{ fontSize: 15, lineHeight: 1.7, color: T.inkMuted }}>{s.body}</div>
              </section>
            ))}
            <div style={{ borderTop: `1px solid ${T.line}`, marginTop: 12, paddingTop: 24 }}>
              <Link to="/terms" style={{ color: T.coral, fontWeight: 700, fontSize: 14, textDecoration: "none", borderBottom: `1px solid ${T.coral}` }}>
                Terms &amp; Conditions →
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </PageShell>
  );
}
